var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Flex from "@irati/ui/src/Flex";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import { FormattedMessage } from "@irati/utils/lang";
var ExploreMore = /** @class */ (function (_super) {
    __extends(ExploreMore, _super);
    function ExploreMore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExploreMore.prototype.render = function () {
        var adminPath = this.props.adminPath;
        var apps = this.context.apps;
        return (React.createElement(Flex, { direction: "row-reverse" },
            React.createElement(ButtonRouterLink, { to: adminPath, app: apps.ADMIN, primary: true },
                React.createElement(FormattedMessage, { id: "admin.reportingV3.home.moreLink" }))));
    };
    ExploreMore.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return ExploreMore;
}(PureComponent));
export default ExploreMore;
